import * as signalR from "@microsoft/signalr";
import { updateFileExportStatus } from "../Api/azure";

class SignalrHelper {
  private logging: boolean = true;
  private initialized: boolean = false;
  private excelExportListenerInitialized: boolean = false;
  private connection: signalR.HubConnection | null = null;

  constructor() {
    this.init();
  }

  init(onStarted?: () => void): SignalrHelper {
    if (this.initialized) return this;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("/updates") // ✅ matches the server's endpoint
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.connection.onclose(() => {
      if (this.logging) console.log("SignalR connection closed.");
      setTimeout(() => this.start(onStarted), 5000);
    });

    this.start(onStarted);
    this.initialized = true;

    return this;
  }

  start(onStarted?: () => void): void {
    if (!this.connection) return;
    if (this.logging) console.log("Trying to start the SignalR connection.");

    this.connection
      .start()
      .then(() => {
        if (this.logging) console.log("SignalR connection started.");
        onStarted?.();
      })
      .catch((err) => {
        console.error("SignalR connection failed:", err);
        setTimeout(() => this.start(onStarted), 5000);
      });
  }

  listenForFileExportEvents(): SignalrHelper {
    if (!this.connection || this.excelExportListenerInitialized) return this;

    if (this.logging)
      console.log("--- Listening for FileExportUpdate events ---");

    this.connection.on(
      "FileExportUpdate",
      (fileId: string, message: string, status: string, url?: string) => {
        if (this.logging) {
          console.log(
            `Incoming FileExportUpdate event`,
            fileId,
            message,
            status,
            url
          );
        }
        updateFileExportStatus(fileId, message, status, url);
      }
    );

    this.excelExportListenerInitialized = true;

    return this;
  }

  listenForChangeRequestUpdates(
    onUpdateCallback: (objectAlternateId: string) => void
  ): SignalrHelper {
    if (!this.connection) return this;

    if (this.logging)
      console.log("--- Listening for ChangeRequestUpdate events ---");

    this.connection.on(
      "ChangeRequestUpdate",
      (type: string, objectAlternateId: string) => {
        if (this.logging) {
          console.log(
            `Incoming ChangeRequestUpdate event`,
            type,
            objectAlternateId
          );
        }
        onUpdateCallback(objectAlternateId);
      }
    );

    return this;
  }
}

export default SignalrHelper;
